import { Component } from 'react';

import { LoginDialogMode } from '../../ui/login/login-modal.component';
import LoginComponent from '../../ui/login/login.component';

import styles from './anonymous-portal.component.module.scss';

interface Props {
    mode?: LoginDialogMode;
    onSuccess?: (mode: string) => void;
}

/**
 * Sign-in shell shown to anonymous visitors landing on /portal.
 * No sidebar, no top bar — just a centered card. The existing
 * <LoginComponent> handles the actual auth.
 */
export default class AnonymousPortal extends Component<Props> {
    render() {
        return (
            <div className={styles.shell}>
                <div className={styles.card}>
                    <div className={styles.logoRow}>
                        <div className={styles.logo}>xC</div>
                        <h1 className={styles.title}>Welcome back</h1>
                        <div className={styles.subtitle}>
                            Sign in to manage your account, plan, and API keys.
                        </div>
                    </div>
                    <div className={styles.loginSlot}>
                        <LoginComponent
                            passwordResetEnabled={true}
                            registerEnabled={true}
                            submitBtnText="Sign in"
                            mode={this.props.mode ?? 'login'}
                            onSuccess={(mode) => this.props.onSuccess?.(mode)}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
